export default "__VITE_ASSET__979eb309__"